import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function RequireAuth({ children, premium = true }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null)
    return (
      <div className="min-h-screen grid place-items-center text-[#A1A1AA]" data-testid="auth-loading">
        <Loader2 className="animate-spin" />
      </div>
    );
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  if (premium && !user.is_premium) return <Navigate to="/premium" replace />;
  return children;
}
